import PptxGenJS from "pptxgenjs";
import {
  map,
  meanBy,
  pick,
  round,
  flatMap,
  take,
  orderBy,
  takeRight,
} from "lodash";
import {
  COLORS,
  getMediaContent,
  getScoreTableRows,
  TEXT_OPTIONS,
} from "../masters/components";
import { TemplateData } from "..";

const RIGHT_COLUMN_X = 8;
const LEFT_COLUMN_X = 0.52;
const CONTENT_Y = 1.54;

export const addExperiencesSlide = (pres: PptxGenJS, data: TemplateData) => {
  const slide = pres.addSlide({ masterName: "SPLIT_LEFT_MASTER" });

  slide.addText("Experiences", { placeholder: "title" });

  if (data.candidateName) {
    slide.addText(data.candidateName, {
      ...TEXT_OPTIONS.caption,
      x: LEFT_COLUMN_X,
      y: 1.14,
      fontSize: 18,
    });
  }

  const experienceEvaluations = data.evaluationRows?.Experience || [];

  const experienceSummaries = map(
    experienceEvaluations,
    (row) => row.summary?.trim() || ""
  ).filter((s) => s !== "");

  slide.addText(
    map(experienceSummaries, (s) => ({
      text: s,
      options: { ...TEXT_OPTIONS.bullet, align: "left", valign: "top" },
    })),
    {
      ...TEXT_OPTIONS.bullet,
      x: LEFT_COLUMN_X,
      y: CONTENT_Y,
      w: 6.5,
      h: 6,
    }
  );

  const groupRows = [
    {
      groupTitle: "Experience dimensions",
      rows: map(experienceEvaluations, (row) => ({
        title: row.title,
        score: round(meanBy(row.evaluations, "evaluation"), 0),
      })),
    },
    // {
    //   groupTitle: "Executive Potential",
    //   rows: map(pick(data.evaluationRows, ["Growth Factors", "Growth Potential", "Potential Realization"]), (rows, groupTitle) => ({
    //     title: groupTitle,
    //     score: getGroupScore(rows)
    //   }))
    // }
  ];

  const tableData = [
    ...getScoreTableRows({
      groupTitle: "Experience dimensions",
      rows: map(experienceEvaluations, (row) => ({
        title: row.title,
        score: round(meanBy(row.evaluations, "evaluation"), 0),
      })),
    }),
  ];

  const tableOptions = {
    x: RIGHT_COLUMN_X,
    y: CONTENT_Y,
    w: 7.3,
    h: 7.57,
    fontSize: 12,
    colspan: 5,
    rowH: 0.58,
    colW: [2.94, 1.13, 1.13, 1.13, 1.13],
  } as const;

  slide.addTable(tableData as any, tableOptions as any);
};
